import React from 'react'
import styled from 'styled-components'

const Styles = styled.div`
  span {
    padding-left: 10px;
  }
  label {
    display: flex;
    align-items: center;
  }

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
`

const Slider = styled.div`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.gray4};
  -webkit-transition: background-color.4s;
  transition: background-color 0.4s;
  border-radius: 10px;

  :before {
    position: absolute;
    content: '';
    height: 8px;
    width: 8px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: transform 0.4s;
    transition: transform 0.4s;
    border-radius: 50%;
  }
`

const Switch = styled.div`
  position: relative;
  display: inline-block;
  width: 23px;
  height: 12px;
`

const StyledSwitch = styled.input.attrs({ type: 'checkbox' })`
  :checked + ${Slider} {
    background-color: ${({ theme }) => theme.colors.green};
  }

  :focus + ${Slider} {
    box-shadow: 0 0 1px ${({ theme }) => theme.colors.green};
  }

  :checked + ${Slider}:before {
    -webkit-transform: translateX(11px);
    -ms-transform: translateX(11px);
    transform: translateX(11px);
  }
`

type Props = {
  isChecked: boolean
  onChange: () => void
}

const ToggleSwitch: React.FC<Props> = (props) => {
  const { isChecked, onChange } = props

  return (
    <Styles {...props}>
      <label>
        <Switch>
          <StyledSwitch checked={isChecked} onChange={onChange} />
          <Slider />
        </Switch>
        <span>Verbose</span>
      </label>
    </Styles>
  )
}

export default ToggleSwitch
